var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.28,
    height: 152.172,
    viewBox: "0 0 375.28 152.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M334.676,10.717h-4.768V35.245h21.72Z",
    transform: "translate(-65.201 -2.118)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M397.453,101.18A18.348,18.348,0,0,0,379.1,119.505v.024h0a18.349,18.349,0,1,0,18.349-18.349Z",
    transform: "translate(-74.924 -20.109)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M334.676,10.717h-4.768V35.245h21.72Z",
    transform: "translate(-65.201 -2.118)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M379.1,119.529h0a18.337,18.337,0,1,0,0-.026Z",
    transform: "translate(-74.924 -20.109)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M391.1,66.513a44.856,44.856,0,0,0-18.349,4V90.936c.325-.3.66-.606,1.011-.893.1-.089.216-.175.328-.261.245-.2.494-.4.74-.6.121-.089.248-.175.36-.262.262-.185.527-.376.788-.552.111-.08.216-.143.328-.223.3-.2.612-.392.925-.583.07-.045.15-.086.213-.128a27.5,27.5,0,0,1,5.245-2.372,26.947,26.947,0,1,1-18.547,25.6c0-.01.006-.026.006-.042V56.368l-17.2,3.826v50.479h-.007a44.151,44.151,0,1,0,44.156-44.16Z",
    transform: "translate(-68.567 -11.253)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M336.227,52v9.134l8.6-1.919V52Z",
    transform: "translate(-66.45 -10.278)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M376.984,53.48V52h-8.6v3.389Z",
    transform: "translate(-72.805 -10.278)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M364.145,52h-17.2v7.215l17.2-3.826Z",
    transform: "translate(-68.568 -10.278)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M385.611,46.8c-1.339,0-2.672.073-3.985.179-.6.045-1.205.086-1.8.16a1.528,1.528,0,0,0-.175.013,51.654,51.654,0,0,0-5.165.839c-.086.022-.176.042-.255.054-.4.089-.787.185-1.18.281-.31.07-.621.153-.931.23-.328.089-.647.179-.972.274-.4.109-.8.23-1.2.351-.255.077-.5.16-.749.236-.653.217-1.308.433-1.945.67V41.866h0L363.4,37.233l-2.576-3.083L336.733.14H319.188V41.866H332.86l-.009,57.656v.038A52.756,52.756,0,1,0,385.61,46.8ZM367.263,99.56v-.026a18.352,18.352,0,1,1,0,.026ZM327.79,33.267V8.739h4.767l16.952,24.528ZM385.611,143.7a44.146,44.146,0,0,1-44.159-44.143h.007V41.866h17.2V99.512c0,.016-.006.032-.006.042a26.934,26.934,0,1,0,18.547-25.6,27.505,27.505,0,0,0-5.245,2.372c-.063.041-.143.083-.213.128-.313.191-.622.383-.925.583-.112.08-.217.143-.328.223-.262.176-.527.367-.788.552-.111.086-.239.172-.36.262-.246.2-.494.4-.74.6-.112.086-.223.172-.328.261-.351.288-.686.591-1.011.893V59.4a44.147,44.147,0,1,1,18.349,84.3Z",
    transform: "translate(-63.083 -0.14)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M36.118,62.582c7.26,0,11.8,4.61,11.8,11.217V99.706H42.081V75.393c0-4.661-1.769-7.381-6.673-7.381-6.313,0-8.439,4.607-8.439,8.025V99.706H21.133V75.393c0-4.425-1.658-7.492-6.323-7.492-6.728,0-8.966,5.191-8.966,9.731V99.706H0V63.469H5.66V68.13a11.8,11.8,0,0,1,10.1-5.548c5.309,0,7.611,2.009,9.852,5.605C28.09,65.357,30.985,62.582,36.118,62.582Z",
    transform: "translate(-0.001 -12.481)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M64.188,63.688h6.67L83.962,89,94.7,63.688h6.016L78.535,114.676H72.159L81.246,95.2Z",
    transform: "translate(-12.686 -12.699)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M114.781,52.513H125.7V64.9a19.059,19.059,0,0,1,11.153-4.126c10.687,0,17,9.029,17,18.888,0,10.095-6.431,18.939-16.643,18.939a15.332,15.332,0,0,1-11.685-4.661v3.778H114.781Zm19.593,18.41c-5.133,0-8.966,3.475-8.966,8.736,0,5.6,3.714,9.208,9.444,9.208,5.366,0,8.082-4.311,8.082-9.445a8.438,8.438,0,0,0-8.561-8.5Z",
    transform: "translate(-22.685 -10.491)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M181.06,97.716H170.076v-45.2H181.06Z",
    transform: "translate(-33.613 -10.491)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M192.578,63.688h10.974V84.46c0,3.963,2.487,6.259,6.2,6.259,3.953,0,6.138-2.3,6.138-5.956V63.688h10.745V85.171c0,10.088-6.552,15.636-17,15.636-10.388,0-17.058-6.016-17.058-16.044Z",
    transform: "translate(-38.06 -12.699)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M241.622,81.693c0-10.981,7.853-18.888,18.534-18.888,10.449,0,17.823,6.9,17.823,19.832,0,.883.064,1.352,0,2.181h-25.5c.95,4.3,4.378,6.377,8.506,6.377,3.593,0,5.963-2.542,7.843-5.019,0,0,6.552,3.775,8.561,5.019-3.189,5.662-9.326,9.437-16.94,9.437C249.3,100.632,241.622,93.851,241.622,81.693Zm18.413-9.683c-3.714,0-5.778,1.77-7.142,5.133H266.65c-1.307-3.475-3.189-5.133-6.615-5.133Z",
    transform: "translate(-47.753 -12.525)",
    fill: "#003c5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M113.93,170.016h-5.844v-45.2h5.844Z",
    transform: "translate(-21.362 -24.78)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M123.158,154.074c0-10.57,7.381-19.185,17.472-19.185,5.251,0,8.79,1.951,12.154,5.9v-5.022h5.494v36.236h-5.612v-4.894a15.6,15.6,0,0,1-12.275,5.9C130.418,173.012,123.158,164.285,123.158,154.074Zm18-13.933c-7.142,0-12.164,6.195-12.164,14.165,0,7.021,5.2,13.341,12.221,13.341,6.967,0,11.925-4.783,11.925-14.106,0-7.614-3.842-13.4-11.982-13.4Z",
    transform: "translate(-24.341 -26.771)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M182.565,164.654v5.363h-5.723v-45.2h5.841v13.751c4.011-4.485,7.493-5.665,12.275-5.665,10.563,0,17.408,8.321,17.408,18.059,0,10.095-6.074,19.825-17.345,19.825C189.65,170.781,184.335,167.832,182.565,164.654Zm11.924-26.56c-7.438,0-12.339,5.188-12.339,14.22,0,8.376,5.2,13.223,12.218,13.223,8.267,0,12.157-7.26,12.157-14.4,0-6.905-4.776-13.041-12.036-13.041Z",
    transform: "translate(-34.95 -24.78)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M226.025,153.955c0-10.095,6.848-19.066,17.584-19.066,10.627,0,16.828,8.615,16.828,19.886H231.812c0,6.845,4.48,13.222,12.157,13.222a11.966,11.966,0,0,0,10.617-7.371l4.9,2.534c-2.359,4.894-8.44,9.917-15.639,9.917C232.873,173.076,226.025,164.1,226.025,153.955Zm17.53-14.166c-6.259,0-10.739,5.187-11.329,10.506h22.248c-.536-5.319-4.074-10.506-10.919-10.506Z",
    transform: "translate(-44.671 -26.771)",
    fill: "#007f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M282.534,170.016h-5.844v-45.2h5.844Z",
    transform: "translate(-54.684 -24.78)",
    fill: "#007f93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.98721417595b03b3636cfd9bf4d84901.svg";
export { ForwardRef as ReactComponent };